import React from "react";

export function CategoryForm({ form, setForm, handleSubmit }) {
  return (
    <div className="container py-4" style={{ maxWidth: "500px" }}>
      <div className="card shadow">
        <div className="card-body">
          <h4 className="text-center mb-4">
            {form.id ? "UPDATE CATEGORY" : "ADD CATEGORY"}
          </h4>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label text-primary fw-bold">CATEGORY NAME</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter category name"
                required
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
              />
            </div>
            <button type="submit" className="btn btn-primary w-100">
              {form.id ? "Update" : "Add"} Category
            </button>
          </form>
        </div>
        <div className="text-center small text-muted py-2">
          © 2025 Category Manager
        </div>
      </div>
    </div>
  );
}
